import type { SearchTrade } from 'lib/sdks/search';

const getTradeTrackingData = (
  trade: SearchTrade,
  showRecentlyReviewedBadgeExp?: boolean,
) => {
  const {
    companyId,
    logoUrl: logo,
    reviewsSummary,
    // This isn't part of V3
    groupId,
    operatingLocationText,
    trackingBadges = [],
    badges,
  } = trade || {};

  const { recentMeanScore, totalReviews } = reviewsSummary || {};

  badges?.forEach(badge => {
    if (!trackingBadges.some(e => e === badge.trackingEventName)) {
      trackingBadges.push(badge.trackingEventName);
    }
  });

  if (
    showRecentlyReviewedBadgeExp &&
    trackingBadges &&
    !trackingBadges?.some(e => e === 'recently-reviewed')
  ) {
    trackingBadges.push('recently-reviewed');
  }

  return {
    trade_id: companyId,
    logo: !!logo,
    score: recentMeanScore,
    // This isn't part of V3
    reviews: totalReviews,
    group_id: groupId,
    location_label: operatingLocationText,
    badges: trackingBadges,
  };
};

export default getTradeTrackingData;
